import { render, staticRenderFns } from "./FileInfoChange.vue?vue&type=template&id=0d1bea1d&scoped=true&"
import script from "./FileInfoChange.vue?vue&type=script&lang=js&"
export * from "./FileInfoChange.vue?vue&type=script&lang=js&"
import style0 from "./FileInfoChange.vue?vue&type=style&index=0&id=0d1bea1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1bea1d",
  null
  
)

export default component.exports